import { render } from "./role_master.vue?vue&type=template&id=54f596f4&scoped=true"
import script from "./role_master.vue?vue&type=script&lang=js"
export * from "./role_master.vue?vue&type=script&lang=js"

import "./role_master.vue?vue&type=style&index=0&id=54f596f4&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\taxbpo_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f596f4"]])

export default __exports__